/**
 * Sistema di logging condizionale per produzione
 * SICUREZZA: In production TUTTI i log sono disabilitati
 * per evitare information disclosure
 */

const isDev = typeof import.meta !== 'undefined' && typeof import.meta.env !== 'undefined'
  ? import.meta.env.DEV
  : false;

// Funzione vuota per produzione
const noop = (...args: unknown[]) => {
  void args;
};

export const logger = {
  /**
   * Log di debug - solo in development
   */
  debug: isDev ? (...args: unknown[]) => console.log(...args) : noop,

  /**
   * Log informativo - solo in development
   */
  info: isDev ? (...args: unknown[]) => console.info(...args) : noop,

  /**
   * Warning - solo in development (sicurezza)
   */
  warn: isDev ? (...args: unknown[]) => console.warn(...args) : noop,

  /**
   * Errore - solo in development (sicurezza)
   */
  error: isDev ? (...args: unknown[]) => console.error(...args) : noop,

  /**
   * Log di gruppo - solo in development
   */
  group: isDev 
    ? (label: string, callback: () => void) => {
        console.group(label);
        callback();
        console.groupEnd();
      }
    : (label: string, callback: () => void) => {
        void label;
        void callback;
      },

  /**
   * Tabella - solo in development
   */
  table: isDev ? (data: unknown) => console.table(data) : noop,

  /**
   * Timer - solo in development
   */
  time: isDev ? (label: string) => console.time(label) : noop,

  timeEnd: isDev ? (label: string) => console.timeEnd(label) : noop
};

// Export per compatibilità
export default logger;
